<script>
/*eslint-disable*/
// import emailjs from 'emailjs-com';
import { ad_url } from "../services/ApiReq.js";
import UltimasNoticiasFooter from "../views/Home/components/Noticias y Frecuentes/UltimasNoticiasFooter.vue";

export default {
	beforeMount() {
		this.ad = ad_url;
	},
	async mounted() {
		await this.$store.dispatch("getUltimasNoticias");
	},
	components: {
		UltimasNoticiasFooter,
	},
	// props:{
	//   item:{
	//     type: Object,
	//     required: true,
	//   }
	// },
	data() {
		return {
			email: "",
			ad: "",
		};
	},
	methods: {
		facebookPoa() {
			window.open(
				`https://www.facebook.com/profile.php?id=100068426351096`
			);
		},
		instagramPoa() {
			window.open(`https://www.instagram.com/club_poa/`);
		},
		// sendEmail(e) {
		//   try {
		//     emailjs.sendForm(process.env.YOUR_SERVICE_ID, process.env.YOUR_TEMPLATE_ID, e.target,
		//     process.env.YOUR_USER_ID, {
		//       name: "Nuevo Suscriptor",
		//       email: this.email,
		//       message: " "
		//     })

		//   } catch(error) {
		//       console.log({error})
		//   }
		//   // Reset form field
		//   this.name = ''
		//   this.email = ''
		//   this.message = ''
		// },
	},
	computed: {
		UltimaNoticia() {
			return this.$store.getters?.ultimas_noticias.slice(0, 4);
		},
	},
};
</script>
<template>
	<footer id="footer" class="">
		<div class="container pt-70 pb-30">
			<div class="row border-bottom-black footer">
				<div class="col-sm-6 col-md-3">
					<div class="widget dark widget-footer">
						<img
							class="mb-10"
							alt=""
							src="../../public/images/log17-200x110.png"
							style="border-radius: 0.25em"
						/>
						<ul id="p-footer-2" style="list-style-type: none; padding: 0;">
							<li>ADOLFO ALSINA 1163, (1088)</li>
							<li>BUENOS AIRES</li>
							<li>ARGENTINA</li>
						</ul>
					</div>
				</div>
				<div class="col-sm-6 col-md-3">
					<div class="widget dark">
						<h2 class="line-bottom">
							LINKS
						</h2>
						<ul
							class="list angle-double-right list-border ul-footer-links"
						>
							<li>
								<a href="/reglamentos/crianza-registro"
									>Reglamentos</a
								>
							</li>
							<li><a href="/calendario">Calendario</a></li>
							<li>
								<a href="/informacion-util/aranceles"
									>Aranceles</a
								>
							</li>
							<!-- <li>
								<a
									href="https://mipoa.clubpoa.com.ar/login"
									target="_blank"
									>Inscripciones</a
								>
							</li> -->
							<li>
								<a
									href="/informacion-util/sede-administrativa-centro"
									>Contacto</a
								>
							</li>
						</ul>
					</div>
				</div>
				<div class="col-sm-6 col-md-3">
					<div class="widget dark">
						<h2 class="line-bottom">
							CONTACTO
						</h2>
						<div class="list-border clearfix">
							<ul class="list-inline mt-5 ul-footer-contacto">
								<li class="m-0 pl-10 pr-10">
									<i
										class="fa fa-phone text-theme-colored mr-5"
									></i>
									<a class="text-gray"
										>+54 (011) 4381-7368 / 9519 / 9596</a
									>
								</li>
								<li class="m-0 pl-10 pr-10">
									<i
										class="fa fa-envelope-o text-theme-colored mr-5"
									></i>
									<a
										href="mailto:poa@clubpoa.com.ar"
										class="text-gray"
										>poa@clubpoa.com.ar</a
									>
								</li>
								<li class="m-0 pl-10 pr-10">
									<i
										class="fa fa-globe text-theme-colored mr-5"
									></i>
									<a class="text-gray">www.clubpoa.com.ar</a>
								</li>
								<li class="m-0 pl-10 pr-10">
									<i
										class="fa fa-facebook text-theme-colored mr-5"
									></i>
									<a
										style="cursor: pointer"
										@click="facebookPoa"
										class="text-gray"
										>Facebook POA Seguinos</a
									>
								</li>
								<li class="m-0 pl-10 pr-10">
									<i
										class="fa fa-instagram text-theme-colored mr-5"
									></i>
									<a
										style="cursor: pointer"
										@click="instagramPoa"
										class="text-gray"
										>Instragram POA Seguinos</a
									>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="entidades">
				<a href="https://www.fci.be/" target="_blank">
					<img src="@/assets/FCI-LOG-18393.png" />
				</a>

				<a href="http://www.fca.org.ar/" target="_blank">
					<img src="@/assets/fca.png" />
				</a>

				<a href="https://www.garikhaus.com/" target="_blank">
					<img src="@/assets/entidad-3.jpg" />
				</a>
				
				<a href="https://www.wusv.org/" target="_blank">
					<img src="@/assets/logo_wusv_portada-300x183.jpg" />
				</a>

				<a href="https://coapa.org/" target="_blank">
					<img src="@/assets/entidad-1.jpg" />
				</a>
			</div>
		</div>

		<div class="footer-bottom bg-footer-abajo">
			<div class="container pt-20 pb-20">
				<div class="row">
					<div class="col-md-6">
						<p class="font-11 text-black-777 m-0">
							Copyright Club Poa. All Rights Reserved
						</p>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<style scoped lang="scss">
.footer {
	display: flex;
	justify-content: center;
}

.publicidad {
	display: flex;
	align-items: center;
	justify-content: center;
}

#p-footer-1,
#p-footer-2 {
	color: #5c5c5c !important;
}

h2 {
	margin: 0 auto;
}

.entidades {
	width: 100%;

	display: flex;
	gap: 25px;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
}

.entidades > a > img {
	height: 80px;
	// width: 75px;
	aspect-ratio: auto;
}
</style>
